import React from "react";
import Hero from "@/components/Hero";
import ServicesGrid from "@/components/ServicesGrid";
import ProblemSelector from "@/components/ProblemSelector";
import TestimonialMarquee from "@/components/TestimonialMarquee";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowRight } from "lucide-react";

export default function HomePage() {
  const { t } = useLanguage();
  return (
    <div data-testid="home-page">
      <Hero />
      <ServicesGrid />
      <ProblemSelector />
      <TestimonialMarquee />

      <section className="py-24 bg-brand-primary text-brand-surface" data-testid="home-final-cta">
        <div className="container-pad text-center max-w-3xl mx-auto">
          <div className="overline text-brand-accent">{t.nav.contact}</div>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl text-brand-surface leading-tight">
            {t.contact.title}
          </h2>
          <p className="mt-5 text-brand-surface/75 text-lg">{t.contact.subtitle}</p>
          <Link
            to="/contact"
            data-testid="home-cta-final"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-accent text-white px-8 py-4 text-sm font-semibold tracking-wide hover:translate-x-1 transition-transform"
          >
            {t.nav.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
